import React, { createContext, useContext, useEffect } from 'react'
import useLocalStorage from '../hooks/useLocalStorage'
import { ExperimentValue } from './amplitude'

// Client-side experiment flags persisted in ABLocalFlags.
// Use this only for temporary local A/B tests that are assigned in the browser.
// (most of the time we don't need to use this, an exception is an experiment on the navbar, footer or the shared layout in general, not page-specific)
const LOCAL_EXPERIMENT_FLAG_KEYS: readonly string[] = []

interface ExperimentContextValue {
  experimentVariants: Record<string, string>
}

const ExperimentContext = createContext<ExperimentContextValue>({ experimentVariants: {} })

export function ExperimentProvider({ children }: { children: React.ReactNode }) {
  const [experimentVariants, setExperimentVariants] = useLocalStorage<Record<string, string>>('ABLocalFlags', {})

  useEffect(() => {
    const localFlags = [...LOCAL_EXPERIMENT_FLAG_KEYS]
    if (localFlags.length === 0) return

    const missingFlags = localFlags.filter((flag) => !(flag in experimentVariants))
    if (missingFlags.length === 0) return

    const newVariants = { ...experimentVariants }
    missingFlags.forEach((flag) => {
      newVariants[flag] = Math.random() < 0.5 ? ExperimentValue.Control : ExperimentValue.Treatment
    })
    setExperimentVariants(newVariants)
  }, [experimentVariants, setExperimentVariants])

  return <ExperimentContext.Provider value={{ experimentVariants }}>{children}</ExperimentContext.Provider>
}

export const useExperiments = () => useContext(ExperimentContext)
